import { useEffect } from "react";
import { hasIubendaConsent, IUBENDA_CONSENT_EVENT, waitForIubendaApi } from "@/lib/iubendaConsent";

let sentryLoaded = false;
let sentryLoading = false;

function loadSentry() {
  if (sentryLoaded || sentryLoading) return;

  sentryLoading = true;

  import("@sentry/react")
    .then((Sentry) => {
      const { replayIntegration, browserTracingIntegration } = Sentry as any;
      Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN as string,
        environment: import.meta.env.MODE,
        tracesSampleRate: 0.2,
        integrations: [
          browserTracingIntegration && browserTracingIntegration(),
          replayIntegration && replayIntegration({ maskAllText: false, blockAllMedia: true }),
        ].filter(Boolean),
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 1.0,
      });

      sentryLoaded = true;
    })
    .catch(() => {
      sentryLoading = false;
    });
}

export default function SentryLoader() {
  useEffect(() => {
    if (!import.meta.env.VITE_SENTRY_DSN) return;

    const syncSentryWithConsent = () => {
      if (hasIubendaConsent()) loadSentry();
    };

    syncSentryWithConsent();
    const stopWaiting = waitForIubendaApi(syncSentryWithConsent);
    window.addEventListener(IUBENDA_CONSENT_EVENT, syncSentryWithConsent as EventListener);

    return () => {
      stopWaiting();
      window.removeEventListener(IUBENDA_CONSENT_EVENT, syncSentryWithConsent as EventListener);
    };
  }, []);

  return null;
}
